import * as React from 'react';
import { connect } from 'react-redux';

import Page from 'components/page/Page';
import SettingsMessage from 'components/settings-message/SettingsMessage';

import CcmCampaignCreateContainer from './components/container/CcmCampaignCreateContainer';

import {
  fetchOrganizationSettings,
  resetOrganizationSettings
} from 'modules/organizations/reducers/organizationSettings';

import { __t, applyTranslations } from 'utils/language';
import { isBrandSettingsPageInComplete } from 'utils/organization';
import { getCcmCampaignTypeFromQuery } from './utils/location-query';

applyTranslations(require('./ccm-campaign-create-page.i18n.json'));

import type {
  LocationWindow,
  OrganizationSettings,
  Params
} from 'types';

type OwnProps = {
  params: Params,
  location: LocationWindow
};

type StateProps = {
  currentOrganizationId: number,
  organizationSettings: OrganizationSettings
};

type DispatchProps = {
  dispatchFetchOrganizationSettings: (currentOrganizationId: number) => void,
  dispatchResetOrganizationSettings: () => void
};

type Props = OwnProps & StateProps & DispatchProps;

const MSG_KEY = 'ccm_campaign_create_page';

const CcmCampaignCreatePage: React.FC<Props> = ({
  location,
  params,
  currentOrganizationId,
  organizationSettings,
  dispatchFetchOrganizationSettings,
  dispatchResetOrganizationSettings
}): JSX.Element => {
  const campaignType = getCcmCampaignTypeFromQuery(location.query);
  const settingsPageIncomplete = isBrandSettingsPageInComplete(organizationSettings);
  const title = __t(`${MSG_KEY}.document_title`);

  React.useEffect(() => {
    dispatchFetchOrganizationSettings(currentOrganizationId);

    return () => {
      dispatchResetOrganizationSettings();
    };
  }, []);

  return (
    <Page
      documentTitle={title}
    >
      {
        settingsPageIncomplete
          ? (
            <SettingsMessage
              organizationId={organizationSettings.id}
              organizationSettings={organizationSettings}
            />
          )
          : (
            <CcmCampaignCreateContainer
              campaignType={campaignType}
              organizationId={currentOrganizationId}
              brandProfileId={Number(params.id)}
            />
          )
      }
    </Page>
  );
};

const mapStateToProps = ({ organizations, organizationSettings }): StateProps => ({
  currentOrganizationId: organizations.currentOrganizationId,
  organizationSettings: organizationSettings.organization
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchOrganizationSettings: (currentOrganizationId: number) => (
    dispatch(fetchOrganizationSettings(currentOrganizationId))
  ),
  dispatchResetOrganizationSettings: () => (
    dispatch(resetOrganizationSettings())
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(CcmCampaignCreatePage);
